import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export default function StatCard({ label, value, sublabel, icon: Icon, accent = "default", testId }) {
  const accentMap = {
    default: "bg-slate-50 text-slate-700",
    emerald: "bg-emerald-50 text-emerald-700",
    rose: "bg-rose-50 text-rose-700",
    indigo: "bg-indigo-50 text-indigo-700",
    amber: "bg-amber-50 text-amber-700",
    sky: "bg-sky-50 text-sky-700",
  };
  return (
    <Card data-testid={testId} className="border-border hover:-translate-y-0.5 hover:shadow-sm transition-all">
      <CardContent className="p-6">
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
              {label}
            </div>
            <div className="mt-2 font-heading text-3xl tracking-tight text-foreground">
              {value}
            </div>
            {sublabel && (
              <div className="mt-1.5 text-xs text-muted-foreground">{sublabel}</div>
            )}
          </div>
          {Icon && (
            <div className={cn("rounded-lg p-2.5", accentMap[accent] || accentMap.default)}>
              <Icon className="h-4 w-4" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
